import { render } from "./FinancaStockTable.vue?vue&type=template&id=4c1d0fec"
import script from "./FinancaStockTable.vue?vue&type=script&lang=js"
export * from "./FinancaStockTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__